<i class="fa fa-info-circle" placement="right" container="body" ngbPopover="{{message}}" triggers="mouseenter:mouseleave">
</i>
